import { NoticeFactory } from '@b2b/common/factories/notice';
import { ApiService } from '@b2b/common/services/api/types';
import { CalendarService } from '@b2b/common/services/calendar';
import { PermissionsService } from '@b2b/common/services/permissions';
import { TODO, UIBModalService } from '@b2b/types/core';
import uiRouter, { StateService } from '@uirouter/angularjs';
import angular, { IFilterService, IQService, IScope, ITimeoutService } from 'angular';
import moment from 'moment-timezone';

export const OrdersCreateControllerModule = angular
  .module('acme.view.application.orders.create.controllers', [
    uiRouter,
    'ui.bootstrap',
    'acme.common.service.api',
    'acme.common.service.calendar',
    'acme.common.service.order',
    'acme.common.service.helpers',
    'acme.common.service.permissions',
    'acme.common.service.auth',
    'acme.common.factory.notice',
    'acme.common.service.templates',
    'acme.common.filter.saleChannel',
    'acme.common.service.userPreferences',
    'acme.view.application.templates.showTemplatesModal.controllers',
  ])

  .controller('OrdersCreateController', [
    '$scope',
    '$state',
    '$filter',
    '$timeout',
    '$q',
    '$uibModal',
    'ApiService',
    'OrderService',
    'HelpersService',
    'CalendarService',
    'PermissionsService',
    'NoticeFactory',
    'TemplatesService',
    'UserPreferencesService',
    function (
      $scope: IScope & { ordersCreate: TODO },
      $state: StateService,
      $filter: IFilterService,
      $timeout: ITimeoutService,
      $q: IQService,
      $uibModal: UIBModalService,
      ApiService: ApiService,
      OrderService: TODO,
      HelpersService: TODO,
      CalendarService: CalendarService,
      PermissionsService: PermissionsService,
      NoticeFactory: NoticeFactory,
      TemplatesService: TODO,
      UserPreferencesService: TODO,
    ) {
      const ctrl = {
        template: {
          name: '',
          startTime: new Date(),
          description: '',
          capacity: 0,
          duration: {
            hour: 1,
            minutes: 30,
          },
          type: 'private',
          priceLists: [],
          addOns: {},
          reviewState: 'published',
          schedules: [] as TODO[],
          ticketDetails: {
            ticketDurationDays: 1,
            expireFromEventDate: false,
          },
        } as TODO,

        partner: {} as TODO,
        customer: {} as TODO,

        accountId: false,
        customerId: false,
        isSubmitted: false,
        isValidated: false,
        templateCreationInProgress: false,
        eventTemplateId: false as string | false,
        isCSR: false,
        showModal: null as TODO,

        eventDate: new Date(),
        eventStartHour: new Date(),
        noticeTimer: '',
        addOnQuantity: 0,
        quantity: 0,
        total: 0,
        events: [] as TODO[],

        event: {} as TODO,
        notice: {} as TODO,

        discounts: [] as TODO[],
        priceLists: [] as TODO[],
        eventTemplates: [] as TODO[],
        enableCSRToggle: false,
        currentTemplate: null as TODO,
        templateDiscount: null as TODO,
        templateDiscounts: null as TODO,
        discountedPriceList: null as TODO,
        discountedAddOns: null as TODO,
        selectedDiscount: null as TODO,
        selectedPriceList: null as TODO,
        selectedEventStartHour: null as TODO,
        selectedEventTemplate: {
          id: null,
          name: 'Custom event...',
          type: null,
          admissionType: null,
        } as TODO,
        colorCodes: angular.copy(TemplatesService.getColorCategory()),
        disableColor: true,
        eventBackgroundColor: '',

        spectrumConfig: {
          titleText: 'Tile color',
          color: TemplatesService.getColorCategory().backgroundColor,
        },
        dateFormat: UserPreferencesService.getDateFormat('fieldDate', 'dateFormat'),
        hourFormat: UserPreferencesService.getDateFormat('standardTime', 'hourFormat'),

        ticketExpirationSetting: [
          {
            name: 'expireFromEventDate',
            label: 'event start',
          },
          {
            name: 'expireFromPurchaseDate',
            label: 'purchase',
          },
        ],

        ticketExpirationSelection: 'expireFromEventDate' as TODO,

        hasOrganization: true,

        toggleCSRPrices: false,
        toggleCSRAddons: false,
        loadedTemplates: false,
        loadedTemplate: false,

        init: function () {
          ctrl.isCSR = PermissionsService.check('CSR');

          if (!PermissionsService.check('ACCT_ORDERS_CREATE')) {
            $state.go('home.default', {}, { notify: true });
          }

          if (PermissionsService.check('CSR')) {
            ctrl.enableCSRToggle = true;
          }

          $scope.$emit('Application::contentTitleChange', {
            title: 'Create Order',
            buttonLeft: {
              label: 'Cancel',
              action: function () {
                ctrl.cancel();
              },
            },
            buttonRight: {
              label: 'Checkout',
              action: function () {
                ctrl.complete();
              },
            },
          });

          $scope.$on('UserPreferencesService:onDateFormatLoad', ctrl.onDateFormatLoad);

          $scope.$watch('ordersCreate.eventDate', ctrl.onTemplateDateChange);
          $scope.$watch('ordersCreate.selectedEventTemplate', ctrl.onEventTemplateChange);
          $scope.$watch('ordersCreate.selectedEventStartHour', ctrl.onEventStartHourChange);
          $scope.$watch('ordersCreate.selectedPriceList', ctrl.onPriceListChange);
          $scope.$watch('ordersCreate.templateDiscounts', ctrl.onTemplateDiscountsLoaded);
          $scope.$watch('ordersCreate.selectedDiscount', ctrl.onSelectedDiscountUpdate);
          $scope.$watch('ordersCreate.colorCodes', ctrl.onColorCodesUpdate);

          ctrl.notice = new NoticeFactory();

          ctrl.ticketExpirationSelection = ctrl.ticketExpirationSetting[0];

          // Init start hour
          ctrl.updateEventStartHour();

          ctrl.resetSchedule();

          if ($state.params.eventTemplateId) {
            console.log('OrdersCreateController::init', $state.params.eventTemplateId);

            ctrl.eventTemplateId = $state.params.eventTemplateId;

            const props = {
              templateId: $state.params.eventTemplateId,
              setSelected: true,
            };

            ctrl.getTemplate(props);
          }

          if ($state.params.accountId) {
            ctrl.accountId = $state.params.accountId;
            ctrl.getPartners(ctrl.accountId);
          }

          if ($state.params.customerId) {
            ctrl.customerId = $state.params.customerId;
            ctrl.getCustomer(ctrl.customerId);
          }

          if (!ctrl.accountId && !ctrl.customerId) {
            //Ideally this should never happen - we're in a weird state. Show an error that organization is required.
            ctrl.notice.showErrorMessages([
              {
                message:
                  'You must choose an Organization before creating this order. Please try creating this order again.',
              },
            ]);
            ctrl.hasOrganization = false;
          }

          ctrl.getPriceLists();
          ctrl.getDiscounts();
        },

        resetSchedule: function () {
          ctrl.template.schedules = [
            {
              name: 'schedule_1',
              description: 'Schedule 1',
              effectiveStartTime: '',
              hours: [
                {
                  hour: 10,
                  minutes: 0,
                  quantity: 1,
                },
              ],
              days: [],
            },
          ];
        },

        setScheduleName: function () {
          ctrl.template.schedules[0].name = ctrl.partner.company.name;
          ctrl.template.schedules[0].description = ctrl.partner.company.name + ' schedule';
        },

        updateEventStartHour: function () {
          var startHour = new Date(ctrl.eventDate);

          startHour.setHours(9);
          startHour.setMinutes(0);
          startHour.setSeconds(0);
          startHour.setMilliseconds(0);

          ctrl.eventStartHour = startHour;
        },

        getEvent: function (id) {
          if (id) {
            ApiService.partners.reseller
              .event({ accountId: ctrl.accountId as TODO, eventId: id })
              .then(ctrl.success.getEvent, ctrl.error.getEvent);
          }
        },

        getEvents: function (id) {
          var times;

          if (id) {
            if (ctrl.eventDate instanceof Date) {
              times = ctrl.getEventTimes();
              console.log('OrdersCreateController::getEventTimes', ctrl.eventDate);

              if (ctrl.accountId) {
                console.log('OrdersCreateController::getEventTimes', ctrl.accountId);
                ApiService.partners.reseller
                  .events({
                    accountId: ctrl.accountId as TODO,
                    templateId: id,
                    startTime: CalendarService.toISO8601(times.startTime),
                    endTime: CalendarService.toISO8601(times.endTime),
                    type: 'private',
                  })
                  .then(ctrl.success.getEvents, ctrl.error.getEvents);
              } else {
                ApiService.event
                  .schedules({
                    templateId: id,
                    startTime: CalendarService.toISO8601(times.startTime),
                    endTime: CalendarService.toISO8601(times.endTime),
                  })
                  .then(ctrl.success.getEvents, ctrl.error.getEvents);
              }
            }
          } else {
            ctrl.resetEvents();
            ctrl.selectedEventStartHour = null;
          }
        },

        getEventTimes: function () {
          var startTime, endTime;

          console.log('OrdersCreateController::getEventTimes', ctrl.eventDate);
          if (ctrl.eventDate instanceof Date) {
            startTime = new Date(ctrl.eventDate);
            startTime.setHours(0);
            startTime.setMinutes(0);
            startTime.setSeconds(0);
            startTime.setMilliseconds(0);

            endTime = new Date(ctrl.eventDate);
            endTime.setHours(23);
            endTime.setMinutes(59);
            endTime.setSeconds(59);
            endTime.setMilliseconds(999);
          }

          return {
            startTime: startTime,
            endTime: endTime,
          };
        },

        getEndTime: function (startTime, duration) {
          return moment(startTime).add(duration.hour, 'hours').add(duration.minutes, 'minutes').format();
        },

        getPartners: function (id) {
          if (id) {
            ApiService.partners.detail(id).then(ctrl.success.getPartners, ctrl.error.getPartners);
          }
        },

        getCustomer: function (id) {
          if (id) {
            ApiService.customers.detail({ customerId: id }).then(ctrl.success.getCustomer, ctrl.error.getCustomer);
          }
        },

        getPriceLists: function () {
          ApiService.price.lists
            .list(HelpersService.getPaginator())
            .then(ctrl.success.getPriceLists, ctrl.error.getPriceLists);
        },

        getDiscounts: function () {
          ApiService.discounts
            .list('v2', HelpersService.getPaginator())
            .then(ctrl.success.getDiscounts, ctrl.error.getDiscounts);
        },

        getTemplate: function (props: { templateId: string; setSelected: boolean }) {
          if (props.templateId) {
            if (props.setSelected) {
              ApiService.program.get(props.templateId).then(function (response) {
                const template = response.data.payload;

                ctrl.selectedEventTemplate = {
                  id: template.id,
                  name: template.name,
                  type: template.type,
                  admissionType: template.admissionType,
                };

                ctrl.success.getTemplate(response);
              }, ctrl.error.getTemplate);
            } else {
              ApiService.program.get(props.templateId).then(ctrl.success.getTemplate, ctrl.error.getTemplate);
            }
          }
        },

        getTemplateDiscounts: function (id) {
          if (id) {
            ApiService.partners.templates
              .detail(id)
              .then(ctrl.success.getTemplateDiscounts, ctrl.error.getTemplateDiscounts);
          }
        },

        getDiscountedPriceList: function () {
          console.log('OrdersCreateController::getDiscountedPriceList', ctrl.selectedDiscount, ctrl.selectedPriceList);
          if (ctrl.selectedDiscount && ctrl.selectedPriceList) {
            console.log(
              'OrdersCreateController::getDiscountedPriceList',
              ctrl.selectedDiscount.id,
              ctrl.selectedPriceList.id,
            );

            ApiService.discounts
              .preview({
                discountId: ctrl.selectedDiscount.id,
                priceListId: ctrl.selectedPriceList.id,
              })
              .then(ctrl.success.getDiscountedPriceList, ctrl.error.getDiscountedPriceList);
          }
        },

        getPartnerDescription: function (partner) {
          var h,
            r = '';

          if (partner) {
            if (partner.company) {
              h = 'Organization information \n';
              r += partner.company.name ? partner.company.name + '\n' : '';
              r += partner.company.streetAddress1 ? partner.company.streetAddress1 + '\n' : '';
              r += partner.company.streetAddress2 ? partner.company.streetAddress2 + '\n' : '';
              r += partner.company.city ? partner.company.city + ', ' : '';
              r += partner.company.state ? partner.company.state + '\n' : '';
              r += partner.company.zip ? partner.company.zip + '\n' : '';
              r += partner.company.country ? partner.company.country + '\n' : '';

              if (r.length > 0) {
                r = h + r + '\n';
              } else {
                r = h + 'No information available \n';
              }
            }

            if (partner.primaryContact) {
              r += 'Primary contact information \n';
              r += partner.primaryContact.name ? partner.primaryContact.name + '\n' : '';
              r += partner.primaryContact.phoneNumber ? partner.primaryContact.phoneNumber + '\n' : '';
              r += partner.primaryContact.streetAddress1 ? partner.primaryContact.streetAddress1 + '\n' : '';
              r += partner.primaryContact.streetAddress2 ? partner.primaryContact.streetAddress2 + '\n' : '';
              r += partner.primaryContact.city ? partner.primaryContact.city + ', ' : '';
              r += partner.primaryContact.state ? partner.primaryContact.state + '\n' : '';
              r += partner.primaryContact.zip ? partner.primaryContact.zip + '\n' : '';
              r += partner.primaryContact.country ? partner.primaryContact.country + '\n' : '';
              if (r.length <= 0) {
                r = h + 'No information available \n';
              }
            }
          }

          return r;
        },

        findPartnerDiscount: function (categoryId) {
          var i,
            ii,
            r = null;

          for (i = 0, ii = ctrl.templateDiscounts.length; i < ii; i++) {
            if (ctrl.templateDiscounts[i].categoryId === categoryId) {
              r = ctrl.templateDiscounts[i];
              break;
            }
          }

          return r;
        },

        findDiscount: function (id) {
          var i,
            ii,
            r = null;

          for (i = 0, ii = ctrl.discounts.length; i < ii; i++) {
            if (ctrl.discounts[i].id === id) {
              r = ctrl.discounts[i];
              break;
            }
          }

          return r;
        },

        findPriceList: function (id) {
          var i,
            ii,
            r = null;

          for (i = 0, ii = ctrl.priceLists.length; i < ii; i++) {
            if (ctrl.priceLists[i].id === id) {
              r = ctrl.priceLists[i];
              break;
            }
          }

          return r;
        },

        isOneTimeEvent: function () {
          return (
            (ctrl.selectedEventStartHour && !ctrl.selectedEventStartHour.id) ||
            (ctrl.selectedEventStartHour &&
              ctrl.selectedEventStartHour.type &&
              ctrl.selectedEventStartHour.type === 'schedule')
          );
        },

        isCustomEvent: function () {
          return (
            (ctrl.selectedEventStartHour && !ctrl.selectedEventStartHour.id) ||
            (ctrl.selectedEventStartHour &&
              ctrl.selectedEventStartHour.type &&
              ctrl.selectedEventStartHour.type !== 'schedule')
          );
        },

        hasDiscountedAddOns: function () {
          return (
            ctrl.discountedAddOns &&
            ctrl.discountedAddOns.inventoryAddOns instanceof Array &&
            ctrl.discountedAddOns.inventoryAddOns.length > 0
          );
        },

        resetModel: function () {
          ctrl.quantity = 0;
          ctrl.total = 0;
        },

        resetEvents: function () {
          ctrl.events = [
            {
              id: false,
              startDate: false,
              startHour: 'Custom Time',
              type: 'custom',
            },
          ];
          ctrl.ticketExpirationSelection = ctrl.ticketExpirationSetting[0];
        },

        resetPriceList: function () {
          var i, ii;

          if (ctrl.discountedPriceList) {
            console.log('OrdersCreateController::resetPriceList -> ctrl.discountedPriceList');

            if (ctrl.discountedPriceList.prices instanceof Array) {
              for (i = 0, ii = ctrl.discountedPriceList.prices.length; i < ii; i++) {
                console.log(
                  'OrdersCreateController::resetPriceList',
                  ctrl.discountedPriceList.prices[i].discountedPrice,
                );
                ctrl.discountedPriceList.prices[i].discountedPrice = ctrl.discountedPriceList.prices[i].price;
                ctrl.discountedPriceList.prices[i].quantity = 0;
              }
            }
          } else {
            console.log('OrdersCreateController::resetPriceList -> !ctrl.discountedPriceList');
          }
          if (ctrl.hasDiscountedAddOns()) {
            console.log('OrdersCreateController::resetPriceList -> ctrl.discountedAddOns');
            for (i = 0, ii = ctrl.discountedAddOns.inventoryAddOns.length; i < ii; i++) {
              console.log(
                'OrdersCreateController::resetPriceList -> ctrl.discountedAddOns',
                ctrl.discountedAddOns.inventoryAddOns[i].price,
              );
              ctrl.discountedAddOns.inventoryAddOns[i].totalQuantity = 0;
            }
          } else {
            console.log('OrdersCreateController::resetPriceList -> !ctrl.discountedAddOns');
          }
        },

        calculateTotal: function () {
          var i,
            ii,
            total = 0,
            quantity = 0,
            currentPrice = 0,
            addOnQuantity = 0;

          if (ctrl.discountedPriceList) {
            console.log('OrdersCreateController::calculateTotal', ctrl.discountedPriceList);

            if (ctrl.discountedPriceList.prices instanceof Array) {
              for (i = 0, ii = ctrl.discountedPriceList.prices.length; i < ii; i++) {
                if (ctrl.discountedPriceList.prices[i].quantity >= 0) {
                  if (!ctrl.toggleCSRPrices) {
                    if (($filter('saleChannel') as TODO)([ctrl.discountedPriceList.prices[i]], '!customerRep').length) {
                      //this item is hidden, set it's total quantity to 0;
                      ctrl.discountedPriceList.prices[i].quantity = 0;
                    }
                  }
                  quantity += ctrl.discountedPriceList.prices[i].quantity;
                  currentPrice = HelpersService.currencyFloatToInteger(
                    ctrl.discountedPriceList.prices[i].discountedPrice,
                  );
                  if (currentPrice >= 0) {
                    total += ctrl.discountedPriceList.prices[i].quantity * currentPrice;
                  }
                }
              }
            } else {
              ctrl.notice.showErrorMessages([
                {
                  message:
                    'No price list found. Please make sure your price list has the reseller sale channel enabled.',
                },
              ]);
            }
          }

          if (ctrl.hasDiscountedAddOns()) {
            console.log('OrdersCreateController::calculateTotal', ctrl.discountedAddOns.inventoryAddOns);
            for (i = 0, ii = ctrl.discountedAddOns.inventoryAddOns.length; i < ii; i++) {
              if (ctrl.discountedAddOns.inventoryAddOns[i].totalQuantity >= 0) {
                if (!ctrl.toggleCSRAddons) {
                  if (
                    ($filter('saleChannel') as TODO)([ctrl.discountedAddOns.inventoryAddOns[i]], '!customerRep').length
                  ) {
                    //this item is hidden, set it's total quantity to 0;
                    ctrl.discountedAddOns.inventoryAddOns[i].totalQuantity = 0;
                  }
                }
                addOnQuantity += ctrl.discountedAddOns.inventoryAddOns[i].totalQuantity;
                currentPrice = HelpersService.currencyFloatToInteger(ctrl.discountedAddOns.inventoryAddOns[i].price);
                if (currentPrice >= 0) {
                  total += ctrl.discountedAddOns.inventoryAddOns[i].totalQuantity * currentPrice;
                }
              }
            }
          }

          ctrl.addOnQuantity = addOnQuantity;
          ctrl.quantity = quantity;
          ctrl.total = HelpersService.integerToCurrencyFloat(total);
        },

        calculatePrice: function (category) {
          var price = category.discountedPrice * category.quantity;

          return price || 0;
        },

        calculateAddOnPrice: function (addon) {
          var price = addon.price * addon.totalQuantity;

          return price || 0;
        },

        togglePrices: function () {
          ctrl.toggleCSRPrices = !ctrl.toggleCSRPrices;
          ctrl.calculateTotal();
        },

        toggleAddons: function () {
          ctrl.toggleCSRAddons = !ctrl.toggleCSRAddons;
          ctrl.calculateTotal();
        },

        showTemplatesModal: function () {
          ctrl.showModal = $uibModal.open({
            templateUrl: 'views/application/views/templates/modals/showTemplates.tpl.html',
            size: 'lg',
            controller: 'TemplatesShowModalController',
            resolve: {
              selectedTemplate: function () {
                return ctrl.selectedEventTemplate;
              },
            },
          });

          ctrl.showModal.result.then(function (template) {
            if (!template) {
              ctrl.selectedEventTemplate = {
                id: false,
                name: 'Custom event...',
              };
            } else {
              ctrl.selectedEventTemplate = template;
            }
          });
        },

        migrate: function () {
          var i,
            ii,
            j,
            jj,
            d = CalendarService.toISO8601(ctrl.eventDate),
            t = CalendarService.toISO8601(ctrl.eventStartHour),
            schedule = {};

          ctrl.template.startTime = d.replace(/(.*?T)\d{2}:\d{2}:\d{2}(.*$)/, '$100:00:00$2');

          if (!(ctrl.template.schedules instanceof Array) || ctrl.template.schedules.length <= 0) {
            ctrl.template.schedules = [];
            ctrl.template.schedules.push(TemplatesService.createSchedule(ctrl.template.startTime));
          }

          if (ctrl.template.ticketDetails) {
            ctrl.template.ticketDetails = angular.extend(TemplatesService.createTicketDetails(), {
              ticketDurationDays: ctrl.template.ticketDetails.ticketDurationDays,
              expireFromEventDate: ctrl.ticketExpirationSelection.name === ctrl.ticketExpirationSetting[0].name,
            });
          } else {
            ctrl.template.ticketDetails = angular.extend(TemplatesService.createTicketDetails(), {
              expireFromEventDate: true,
            });
          }

          // because of the offschedule API we need to set this up
          ctrl.template.id = ctrl.selectedEventTemplate.id || false;

          if (ctrl.template.id) {
            if (ctrl.selectedEventStartHour && ctrl.selectedEventStartHour.id) {
              if (ctrl.selectedEventStartHour.type === 'event') {
                ctrl.template.eventId = ctrl.selectedEventStartHour.id;
                ctrl.template.scheduleId = ctrl.selectedEventStartHour.scheduleId;
                ctrl.template.startTime = ctrl.selectedEventStartHour.startTime;
                ctrl.template.endTime = ctrl.selectedEventStartHour.endTime;
                ctrl.template.resources = ctrl.selectedEventStartHour.resources || [];
              } else {
                ctrl.template.scheduleId = ctrl.selectedEventStartHour.id;
                ctrl.template.startTime = moment(ctrl.selectedEventStartHour.startTime).format();
                ctrl.template.endTime = ctrl.getEndTime(ctrl.template.startTime, ctrl.template.duration);

                if (ctrl.selectedEventStartHour.schedule && ctrl.selectedEventStartHour.schedule.resourceRequests) {
                  ctrl.template.resources = ctrl.processResourceRequests(
                    ctrl.selectedEventStartHour.schedule.resourceRequests,
                  );
                }

                if (ctrl.selectedEventStartHour.schedule) {
                  ctrl.template.salesChannels = ctrl.selectedEventStartHour.schedule.salesChannels.map(function (item) {
                    if (item.name.toLowerCase() === 'web') {
                      item.enabled = false;
                    }
                    return item;
                  });
                }
              }
            } else {
              ctrl.template.startTime = d.split('T')[0] + 'T' + t.split('T')[1];
              ctrl.template.endTime = ctrl.getEndTime(ctrl.template.startTime, ctrl.template.duration);
            }
          }

          if (ctrl.partner && ctrl.partner.company) {
            ctrl.template.organization = ctrl.partner.company;
          }

          ctrl.template.images = [];
          // Do not change colorCategory

          ctrl.template.schedules[0].days[0] = d.split('T')[0];
          ctrl.template.schedules[0].effectiveStartTime = d.split('T')[0] + 'T' + t.split('T')[1];
          ctrl.template.schedules[0].capacity = ctrl.template.capacity;
          ctrl.template.schedules[0].duration = ctrl.template.duration;

          if (
            ctrl.selectedEventStartHour &&
            ctrl.selectedEventStartHour.id &&
            ctrl.selectedEventStartHour.type === 'schedule'
          ) {
            schedule = angular.extend({}, ctrl.selectedEventStartHour.schedule);
            ctrl.template.schedules[0].hours = [ctrl.selectedEventStartHour.hour];
          } else {
            ctrl.template.schedules[0].hours[0].hour = parseInt(t.split('T')[1].split(':')[0], 10);
            ctrl.template.schedules[0].hours[0].minutes = parseInt(t.split('T')[1].split(':')[1], 10);
            ctrl.template.schedules[0].hours[0].quantity = 1;
          }

          if (ctrl.isOneTimeEvent()) {
            ctrl.template.schedules[0].honorHolidays = false;
            ctrl.template.schedules[0].honorOpenHours = false;
          }

          if (ctrl.hasDiscountedAddOns()) {
            ctrl.template.addOns = angular.copy(ctrl.discountedAddOns);
            for (i = 0, ii = ctrl.template.addOns.inventoryAddOns.length; i < ii; i++) {
              ctrl.template.addOns.inventoryAddOns[i].totalQuantity = null;
              ctrl.template.addOns.inventoryAddOns[i].discountedPrice = null;
              delete ctrl.template.addOns.inventoryAddOns[i].totalQuantity;
              delete ctrl.template.addOns.inventoryAddOns[i].discountedPrice;
            }
          }

          if (ctrl.discountedPriceList && ctrl.discountedPriceList.hasOwnProperty('prices')) {
            if (!(ctrl.template.priceLists instanceof Array) || ctrl.template.priceLists.length <= 0) {
              ctrl.template.priceLists = [];
              ctrl.template.priceLists.push(ctrl.discountedPriceList);
            } else {
              ctrl.template.priceLists[0] = ctrl.discountedPriceList;
            }
            ctrl.clearSaleChannels(ctrl.template.priceLists[0].prices);
          } else if (ctrl.selectedPriceList) {
            if (!(ctrl.template.priceLists instanceof Array) || ctrl.template.priceLists.length <= 0) {
              ctrl.template.priceLists = [];
              ctrl.template.priceLists.push(ctrl.selectedPriceList);
            } else {
              ctrl.template.priceLists[0] = ctrl.selectedPriceList;
            }
            ctrl.clearSaleChannels(ctrl.template.priceLists[0].prices);
          } else {
            ctrl.notice.showErrorMessages([{ message: 'You must select a price list to create an order.' }]);
          }
        },

        clearSaleChannels: function (prices) {
          var i, ii, j, jj;
          // Clear sales channels
          console.log('OrdersCreateController::migrate', prices);
          for (i = 0, ii = prices.length; i < ii; i++) {
            for (j = 0, jj = prices[i].salesChannels.length; j < jj; j++) {
              if (
                prices[i].salesChannels[j].channel === 'manualEntry' ||
                prices[i].salesChannels[j].channel === 'customerRep' ||
                prices[i].salesChannels[j].channel === 'reseller'
              ) {
                prices[i].salesChannels[j].enabled = true;
              } else {
                prices[i].salesChannels[j].enabled = false;
              }
            }
          }
        },

        migrateDiscounts: function (eventTemplateId) {
          console.log('OrdersCreateController::migrateDiscounts', ctrl.selectedDiscount);
          return [
            {
              eventTemplateId: eventTemplateId,
              categoryId: ctrl.partner.accountCategoryRelation.categoryId,
              discountId: ctrl.selectedDiscount && ctrl.selectedDiscount.id ? ctrl.selectedDiscount.id : null,
            },
          ];
        },

        hasSelectedStartHour: function () {
          return (
            ctrl.selectedEventStartHour &&
            ctrl.selectedEventStartHour.id &&
            ctrl.selectedEventStartHour.type !== 'schedule'
          );
        },

        isValidExpireDays: function () {
          var r = true;

          if (ctrl.isSubmitted || ctrl.isValidated) {
            r = ctrl.template.ticketDetails && ctrl.template.ticketDetails.ticketDurationDays >= 0;
          }

          return r;
        },

        isValidStartHour: function () {
          var r = true;

          if (ctrl.isSubmitted || ctrl.isValidated) {
            r = ctrl.selectedEventStartHour;
          }

          return r;
        },

        isValidName: function () {
          var r = true;

          if (ctrl.isSubmitted || ctrl.isValidated) {
            r = !!(ctrl.template.name && ctrl.template.name.length > 0);
          }

          return r;
        },

        isValidPriceList: function () {
          var r = true;

          if (ctrl.isSubmitted || ctrl.isValidated) {
            r = ctrl.discountedPriceList && ctrl.discountedPriceList.hasOwnProperty('prices');
          }

          return r;
        },

        isValidCapacity: function () {
          var r = true;

          if (ctrl.isSubmitted || ctrl.isValidated) {
            if (ctrl.hasSelectedStartHour()) {
              r = parseInt(ctrl.selectedEventStartHour.capacity, 10) > 0;
            } else {
              r = parseInt(ctrl.template.capacity, 10) > 0;
            }
          }

          return r;
        },

        isValidQuantity: function () {
          var r = true;

          if (ctrl.isSubmitted || ctrl.isValidated) {
            r = ctrl.quantity > 0;
          }

          return r;
        },

        isValidAvailability: function () {
          var r = true;

          if (ctrl.isSubmitted || ctrl.isValidated) {
            if (ctrl.hasSelectedStartHour()) {
              r = +ctrl.selectedEventStartHour.capacity - +ctrl.selectedEventStartHour.soldQuantity >= ctrl.quantity;
              console.log(
                'OrdersCreateController::isValidQuantity',
                ctrl.selectedEventStartHour.capacity - ctrl.selectedEventStartHour.soldQuantity,
              );
            } else {
              r = +ctrl.template.capacity >= ctrl.quantity;
              console.log(
                'OrdersCreateController::isValidQuantity',
                ctrl.template.capacity,
                ctrl.quantity,
                ctrl.quantity > 0 && +ctrl.template.capacity >= ctrl.quantity,
              );
            }
          }

          return r;
        },

        validate: function () {
          var r = false;

          ctrl.isValidated = true;

          if (
            ctrl.isValidName() &&
            ctrl.isValidPriceList() &&
            ctrl.isValidStartHour() &&
            ctrl.isValidCapacity() &&
            ctrl.isValidAvailability() &&
            ctrl.isValidQuantity() &&
            ctrl.isValidExpireDays()
          ) {
            r = true;
          } else if (!ctrl.isValidQuantity()) {
            ctrl.notice.showErrorMessages([{ message: 'You must add tickets to the order.' }]);
          } else {
            ctrl.notice.showErrorMessages([{ message: 'Please correct the errors below.' }]);
          }

          return r;
        },

        createCustom: function () {
          ctrl.selectedEventTemplate = {
            id: false,
            name: 'Custom event...',
          };
          ctrl.resetEvents();
        },

        processResourceRequests: function (requests) {
          var r: TODO = false;

          if (requests instanceof Array) {
            r = requests.map(function (item) {
              return item.eventResource;
            });
          }

          return r;
        },

        complete: function () {
          ctrl.isSubmitted = true;
          ctrl.isValidated = false;

          if (ctrl.validate()) {
            ctrl.migrate();
            ctrl.notice.hideSuccessMessages();
            ctrl.notice.hideErrorMessages();

            // TODO: This needs to be based on whether or not an event instance has been selected
            if (ctrl.selectedEventTemplate) {
              // Use the current template and update it if one has been selected
              if (ctrl.accountId || ctrl.customerId) {
                // if is from a existing template
                // if a private or a public schedule is selected
                if (ctrl.selectedEventTemplate.id && ctrl.selectedEventStartHour && ctrl.selectedEventStartHour.id) {
                  // if its a private schedule
                  if (ctrl.selectedEventStartHour.type === 'schedule') {
                    ApiService.event.createFromPrivateSchedule(ctrl.template).then(function (response) {
                      var res = response;

                      // saving resources one by one
                      if (
                        ctrl.selectedEventStartHour.schedule.hasOwnProperty('resourceRequests') &&
                        ctrl.selectedEventStartHour.schedule.resourceRequests instanceof Array &&
                        ctrl.selectedEventStartHour.schedule.resourceRequests.length
                      ) {
                        ctrl.selectedEventStartHour.schedule.resourceRequests
                          .reduce(function (promise, item) {
                            return promise.then(function () {
                              return ApiService.program.resources.instance.create({
                                id: res.data.payload.id,
                                sendEmail: true,
                                resourceTimeFrame: item.resourceTimeFrame,
                                eventResource: item.eventResource,
                                notes: item.notes,
                              });
                            });
                          }, $q.when(null))
                          .then(
                            function () {
                              ctrl.success.complete(res.data.payload);
                            },
                            function () {
                              ctrl.error.complete({
                                data: {
                                  error: 'Resource requests could not been created.',
                                },
                              });
                            },
                          );
                      } else {
                        ctrl.success.complete(res.data.payload);
                      }
                    }, ctrl.error.complete);
                  } else {
                    // This means that existing instance has been selected
                    // We need to book against the instance and not create a new template
                    console.log('OrdersCreateController::complete', ctrl.selectedEventStartHour);
                    ctrl.success.complete(ctrl.selectedEventStartHour);
                  }
                } else {
                  // no template selected
                  console.log('OrdersCreateController::complete', ctrl.template);

                  if (!ctrl.templateCreationInProgress) {
                    ctrl.templateCreationInProgress = true;

                    // If no event start hour has been selected we need to create a new template
                    ApiService.program.create(ctrl.template).then(function (response) {
                      const eventTemplateId = response.data.payload.id;

                      if (ctrl.accountId) {
                        ApiService.partners.templates
                          .update({
                            eventTemplateId: eventTemplateId,
                            data: ctrl.migrateDiscounts(eventTemplateId),
                          })
                          .then(function (response) {
                            // Template has been created now grab the only instance in the newly created template
                            const times = ctrl.getEventTimes();
                            const data: TODO = {
                              accountId: ctrl.accountId,
                              templateId: eventTemplateId,
                              startTime: CalendarService.toISO8601(times.startTime),
                              endTime: CalendarService.toISO8601(times.endTime),
                            };

                            if (ctrl.customerId) {
                              data.customerId = ctrl.customerId;
                            }

                            ApiService.partners.reseller.events(data).then(function (response) {
                              // Since we are always creating a new template with a single schedule
                              // We always want the first schedule in the list
                              if (response.data.payload && response.data.payload.length) {
                                ctrl.success.complete(response.data.payload[0]);
                              } else {
                                //the event instance wasn't created - perhaps it was an event in the past?
                                ctrl.error.complete({
                                  data: {
                                    error:
                                      'The event you requested could not be created. Please ensure the event date and time is in the future.',
                                  },
                                });
                              }
                            }, ctrl.error.complete);
                          }, ctrl.error.complete);
                      } else if (ctrl.customerId) {
                        const times = ctrl.getEventTimes();

                        ApiService.event
                          .list({
                            page: -1,
                            pageSize: 1,
                            templateId: eventTemplateId,
                            startTime: CalendarService.toISO8601(times.startTime),
                            endTime: CalendarService.toISO8601(times.endTime),
                          })
                          .then((response) => ctrl.success.complete(response.data.payload.list[0]))
                          .catch((response) => ctrl.error.complete(response));
                      }
                    }, ctrl.error.complete);
                  }
                }
              }
            }
          } else {
            ctrl.isSubmitted = false;
          }
        },

        cancel: function () {
          if (ctrl.accountId) {
            $state.go('application.partners.detail', { id: ctrl.accountId });
          } else {
            $state.go('application.partners.list.default');
          }
        },

        isEventCSREnabled: function (salesChannels) {
          var r = true;
          salesChannels.forEach(function (salesChannel) {
            if (salesChannel.channel === 'customerRep') {
              r = salesChannel.enabled;
            }
          });
          return r;
        },

        processEvents: function (events) {
          var i,
            ii,
            _events: TODO[] = [];

          for (i = 0, ii = events.length; i < ii; i++) {
            if (events[i].salesChannels instanceof Array && events[i].salesChannels.length) {
              // include the events only if they are CSR enabled
              // and NOT off schedule (aka private Order Requests) - ENG-4293
              if (
                (!ctrl.isCSR || ctrl.isEventCSREnabled(events[i].salesChannels)) &&
                !events[i].offSchedule &&
                events[i].type === 'standard'
              ) {
                _events.push(ctrl.processEvent(events[i]));
              }
            }
          }

          return _events;
        },

        processEvent: function (event) {
          event.startDate = $filter('date')(CalendarService.parseDate(event.startTime), ctrl.dateFormat);
          event.startHour = $filter('date')(CalendarService.parseDate(event.startTime), ctrl.hourFormat);
          event.type = 'event';

          return event;
        },

        getPrivateSchedulesEventTimes: function () {
          const events: TODO[] = [];

          angular.forEach(ctrl.currentTemplate.schedules, function (item, index) {
            if (item.type === 'private') {
              angular.forEach(item.hours, function (opening) {
                var date = new Date(ctrl.eventDate);

                date.setHours(opening.hour);
                date.setMinutes(opening.minutes);
                date.setSeconds(0);
                date.setMilliseconds(0);

                events.push({
                  id: item.id,
                  startDate: $filter('date')(CalendarService.parseDate(date), ctrl.dateFormat),
                  startHour: $filter('date')(CalendarService.parseDate(date), ctrl.hourFormat) + ' (private)',
                  startTime: CalendarService.parseDate(date),
                  hour: opening,
                  type: 'schedule',
                  schedule: item,
                });
              });
            }
          });

          return events;
        },

        success: {
          init: function (response) {
            ctrl.eventTemplates = [
              {
                id: false,
                name: 'Custom event...',
              },
            ].concat(response.data.payload.list);
          },

          getPartners: function (response) {
            ctrl.partner = response.data.payload;
            ctrl.template.description = ctrl.getPartnerDescription(ctrl.partner);
          },

          getCustomer: function (response) {
            var fullName: TODO[] = [];

            ctrl.customer = response.data.payload;
            if (ctrl.customer.prefix) {
              fullName.push(ctrl.customer.prefix);
            }
            if (ctrl.customer.firstName) {
              fullName.push(ctrl.customer.firstName);
            }
            if (ctrl.customer.middleName) {
              fullName.push(ctrl.customer.middleName);
            }
            if (ctrl.customer.lastName) {
              fullName.push(ctrl.customer.lastName);
            }
            if (ctrl.customer.suffix) {
              fullName.push(ctrl.customer.suffix);
            }
            ctrl.customer.fullName = fullName.join(' ');
          },

          getTemplate: function (response) {
            //if template is in draft state, flag it it as such.
            ctrl.currentTemplate = response.data.payload;
            ctrl.template.name = ctrl.currentTemplate.name;

            if (ctrl.currentTemplate.customFields !== undefined && ctrl.currentTemplate.customFields !== null) {
              ctrl.template.customFields = ctrl.currentTemplate.customFields;
            }

            if (ctrl.currentTemplate.GLCode !== undefined && ctrl.currentTemplate.GLCode !== null) {
              ctrl.template.GLCode = ctrl.currentTemplate.GLCode;
            }

            if (ctrl.currentTemplate.resources instanceof Array && ctrl.currentTemplate.resources.length > 0) {
              ctrl.template.resources = ctrl.currentTemplate.resources;
            }

            ctrl.template.description =
              HelpersService.strip(ctrl.currentTemplate.description, 300) || ctrl.currentTemplate.shortDescription;
            ctrl.template.shortDescription = ctrl.currentTemplate.shortDescription;

            if (ctrl.currentTemplate.schedules instanceof Array && ctrl.currentTemplate.schedules.length > 0) {
              ctrl.template.capacity = ctrl.currentTemplate.schedules[0].capacity;
              ctrl.template.duration = ctrl.currentTemplate.schedules[0].duration;
            }

            ctrl.setTicketDetails();

            if (ctrl.currentTemplate.emailConfirmationMessage) {
              ctrl.template.emailConfirmationMessage = ctrl.currentTemplate.emailConfirmationMessage;
            }

            if (ctrl.currentTemplate.emailCancellationMessage) {
              ctrl.template.emailCancellationMessage = ctrl.currentTemplate.emailCancellationMessage;
            }

            if (ctrl.currentTemplate.emailNotify) {
              ctrl.template.emailNotify = angular.copy(ctrl.currentTemplate.emailNotify);
            }

            if (ctrl.currentTemplate.onlinePaymentsForOrgOrdersEmailNotify) {
              ctrl.template.onlinePaymentsForOrgOrdersEmailNotify = angular.copy(
                ctrl.currentTemplate.onlinePaymentsForOrgOrdersEmailNotify,
              );
            }

            if (ctrl.currentTemplate.colorCategory) {
              if (ctrl.currentTemplate.colorCategory.backgroundColor && ctrl.currentTemplate.colorCategory.textColor) {
                ctrl.template.colorCategory = angular.copy(ctrl.currentTemplate.colorCategory);
                ctrl.spectrumConfig.color = ctrl.currentTemplate.colorCategory.backgroundColor;
              }
            } else {
              ctrl.template.colorCategory = angular.copy(TemplatesService.getColorCategory());
              ctrl.spectrumConfig.color = TemplatesService.getColorCategory().backgroundColor;
            }

            if (ctrl.currentTemplate.priceLists instanceof Array && ctrl.currentTemplate.priceLists.length > 0) {
              ctrl.selectedPriceList = ctrl.findPriceList(ctrl.currentTemplate.priceLists[0].id);
              ctrl.discountedPriceList = ctrl.currentTemplate.priceLists[0];
            } else {
              ctrl.selectedPriceList = null;
            }
            //pick a pricelist if the template doesn't have it
            ctrl.discountedAddOns =
              ctrl.currentTemplate.hasOwnProperty('addOns') &&
              ctrl.currentTemplate.addOns.inventoryAddOns instanceof Array
                ? ctrl.currentTemplate.addOns
                : { inventoryAddOns: [] };
            ctrl.getTemplateDiscounts(ctrl.currentTemplate.id);

            ctrl.getEvents(ctrl.currentTemplate.id);

            console.log('OrdersCreateController::success::getTemplate', ctrl.discountedAddOns);
          },

          getTemplateDiscounts: function (response) {
            const discounts = response.data.payload;

            if (discounts instanceof Array && discounts.length > 0) {
              console.log('OrdersCreateController::getTemplateDiscounts -> templateDiscounts');
              ctrl.templateDiscounts = discounts;
              $timeout(function () {
                ctrl.getDiscountedPriceList();
              }, 100);
            } else {
              console.log('OrdersCreateController::getTemplateDiscounts -> reset');
              ctrl.selectedDiscount = false;
              ctrl.resetPriceList();
            }
          },

          getDiscountedPriceList: function (response) {
            if (ctrl.discountedPriceList && ctrl.discountedPriceList.hasOwnProperty('prices')) {
              ctrl.discountedPriceList = angular.extend(ctrl.discountedPriceList, response.data.payload);
            } else {
              ctrl.discountedPriceList = response.data.payload;
            }

            ctrl.calculateTotal();
          },

          getEvent: function (response) {
            ctrl.event = response.data.payload;
            ctrl.discountedPriceList = ctrl.event.priceLists[0];
          },

          getEvents: function (response) {
            let events: TODO[] = [];
            let privateEvents: TODO = {};

            ((events = []), (privateEvents = ctrl.getPrivateSchedulesEventTimes()));

            if (response.data && response.data.payload instanceof Array && response.data.payload.length > 0) {
              events = ctrl.processEvents(response.data.payload);
            } else if (response.payload instanceof Array && response.payload.length > 0) {
              events = ctrl.processEvents(response.payload);
            } else {
              // Default to nothing
              ctrl.selectedEventStartHour = null;
            }

            ctrl.events = [];
            ctrl.events = privateEvents.concat(events);

            ctrl.events.push({
              id: false,
              startDate: false,
              startHour: 'Custom Time',
              type: 'custom',
            });

            if (privateEvents.length) {
              ctrl.selectedEventStartHour = ctrl.events[0];
            }
          },

          getPriceLists: function (response) {
            ctrl.priceLists = response.data.payload.list;
          },

          getDiscounts: function (response) {
            ctrl.discounts = response.data.payload.list;
          },

          // Unique in that it only accepts an event instance that may or may not have come from a newly created template
          complete: function (event) {
            const stateParams: TODO = { eventId: event.id };
            const data: TODO = {
              eventId: event.id,
              priceList: ctrl.discountedPriceList,
              addOns: ctrl.discountedAddOns,
              toggleCSRPrices: ctrl.toggleCSRPrices,
              toggleCSRAddons: ctrl.toggleCSRAddons,
            };

            if (ctrl.accountId) {
              stateParams.accountId = data.accountId = ctrl.accountId;
            }

            if (ctrl.customerId) {
              stateParams.customerId = data.customerId = ctrl.customerId;
            }

            OrderService.store(data);

            $state.go('application.orders.checkout', stateParams);
            console.log('OrdersCreateController::complete', 'application.orders.checkout', {
              customerId: ctrl.customerId,
              accountId: ctrl.accountId,
              id: event.id,
              csr: ctrl.toggleCSRPrices,
              addons: ctrl.toggleAddons,
            });

            $timeout(function () {
              ctrl.isSubmitted = false;
              ctrl.templateCreationInProgress = false;
            }, 100);
          },
        },

        error: {
          init: function (response) {
            // noop
          },
          initSources: function (response) {
            // noop
          },
          getPartners: function (response) {
            // noop
          },
          getCustomer: function (response) {
            // noop
          },
          getTemplateDiscounts: function (response) {
            ctrl.loadedTemplate = false;
          },
          getEvent: function (response) {
            // noop
          },
          getEvents: function (response) {
            // noop
          },
          getPriceLists: function (response) {
            // noop
          },
          getDiscounts: function (response) {
            // noop
          },
          getTemplate: function (response) {
            // noop
          },
          getDiscountedPriceList: function (response) {
            // noop
          },
          complete: function (response) {
            ctrl.isSubmitted = false;
            ctrl.templateCreationInProgress = false;
            ctrl.notice.showErrorMessages([{ message: response.data.error }]);
          },
        },

        onEventStartHourChange: function (n, o) {
          if (n && n.id) {
            if (n.type === 'schedule') {
              ctrl.template.type = 'private';
              ctrl.template.capacity = n.schedule.capacity;
              ctrl.template.duration = n.schedule.duration;
              ctrl.template.schedules[0].name = n.schedule.name;
              if (
                n.schedule.priceLists instanceof Array &&
                n.schedule.priceLists.length &&
                (!ctrl.discountedPriceList || ctrl.discountedPriceList.id !== n.schedule.priceLists[0].id)
              ) {
                ctrl.discountedPriceList = n.schedule.priceLists[0];
              }
            } else {
              // Existing Event
              ctrl.template.type = 'standard';
              ctrl.discountedPriceList = n.priceList;
              // Save old selection of color codes
              ctrl.disableColor = true;
              if (n.colorCategory.backgroundColor) {
                ctrl.eventBackgroundColor = n.colorCategory.backgroundColor;
              }
              ctrl.resetSchedule();
              console.log('OrdersCreateController::onEventStartHourChange -> n.id', n, ctrl.discountedPriceList.id);
            }
          } else {
            // New Event Creation
            ctrl.template.type = 'private';
            ctrl.event = {};
            ctrl.disableColor = false;
            ctrl.eventBackgroundColor = TemplatesService.getColorCategory().backgroundColor;
            ctrl.resetSchedule();
            console.log('OrdersCreateController::onEventStartHourChange -> !n.id', ctrl.selectedEventTemplate);

            if (ctrl.selectedEventTemplate && ctrl.selectedEventTemplate.id) {
              if (ctrl.currentTemplate.schedules instanceof Array && ctrl.currentTemplate.schedules.length > 0) {
                ctrl.template.capacity = ctrl.currentTemplate.schedules[0].capacity;
                ctrl.template.duration = ctrl.currentTemplate.schedules[0].duration;
              }

              if (ctrl.currentTemplate.priceLists instanceof Array && ctrl.currentTemplate.priceLists.length > 0) {
                ctrl.selectedPriceList = ctrl.findPriceList(ctrl.currentTemplate.priceLists[0].id);
                ctrl.discountedPriceList = ctrl.currentTemplate.priceLists[0];
              } else {
                ctrl.selectedPriceList = null;
              }
            } else {
              //ctrl.discountedPriceList = false;
            }
            // console.log('OrdersCreateController::onEventStartHourChange -> !n.id', ctrl.discountedPriceList.id);
          }

          ctrl.setTicketDetails();

          ctrl.calculateTotal();
        },

        /*
         * Sets the ticket expiration duration (in days) from currently selected template
         * Also translates the expirationFromEventDate flag to the ticketExpirationSetting Enum for display
         */
        setTicketDetails: function () {
          if (ctrl.currentTemplate && ctrl.currentTemplate.ticketDetails) {
            ctrl.template.ticketDetails.ticketDurationDays = ctrl.currentTemplate.ticketDetails.ticketDurationDays;
            ctrl.ticketExpirationSelection =
              ctrl.currentTemplate.ticketDetails && ctrl.currentTemplate.ticketDetails.expireFromEventDate
                ? ctrl.ticketExpirationSetting[0]
                : ctrl.ticketExpirationSetting[1];
          } else {
            ctrl.template.ticketDetails.ticketDurationDays = 365;
            ctrl.ticketExpirationSelection = ctrl.ticketExpirationSetting[0];
          }
        },

        onTemplateDateChange: function (n, o) {
          if (ctrl.selectedEventTemplate) {
            if (ctrl.selectedEventTemplate.id) {
              ctrl.getEvents(ctrl.selectedEventTemplate.id);
            } else {
              ctrl.resetEvents();
            }
          } else {
            ctrl.resetEvents();
          }
          ctrl.updateEventStartHour();
        },

        onTemplateDiscountsLoaded: function (n, o) {
          if (n) {
            if (
              ctrl.selectedEventTemplate &&
              ctrl.selectedEventTemplate.id &&
              ctrl.partner &&
              ctrl.partner.accountCategoryRelation
            ) {
              ctrl.templateDiscount = ctrl.findPartnerDiscount(ctrl.partner.accountCategoryRelation.categoryId);
              if (ctrl.templateDiscount) {
                ctrl.selectedDiscount = ctrl.findDiscount(ctrl.templateDiscount.discountId);
              } else {
                ctrl.selectedDiscount = false;
                ctrl.resetPriceList();
              }
            }
            console.log(
              'OrdersCreateController::onTemplateDiscountsLoaded',
              ctrl.templateDiscount,
              ctrl.selectedDiscount,
            );
          }
        },

        onSelectedDiscountUpdate: function (n, o) {
          if (n) {
            if (
              ctrl.selectedEventTemplate &&
              ctrl.selectedEventTemplate.id &&
              ctrl.partner &&
              ctrl.partner.accountCategoryRelation
            ) {
              ctrl.templateDiscount = ctrl.findPartnerDiscount(ctrl.partner.accountCategoryRelation.categoryId);
              if (ctrl.templateDiscount) {
                ctrl.selectedDiscount = ctrl.findDiscount(ctrl.templateDiscount.discountId);
              } else {
                ctrl.resetPriceList();
              }
            } else {
              if (ctrl.selectedPriceList && ctrl.selectedDiscount) {
                ctrl.getDiscountedPriceList();
              } else {
                ctrl.resetPriceList();
              }
            }

            console.log(
              'OrdersCreateController::onSelectedDiscountUpdate',
              ctrl.templateDiscount,
              ctrl.selectedDiscount,
            );
          } else {
            ctrl.resetPriceList();
            console.log('OrdersCreateController::onSelectedDiscountUpdate -> reset');
          }
          ctrl.calculateTotal();
        },

        onEventTemplateChange: function (n, o) {
          let reset = false;

          if (ctrl.accountId || ctrl.customerId) {
            ctrl.notice.hideSuccessMessages();
            ctrl.notice.hideErrorMessages();
          }

          ctrl.isSubmitted = false;

          if (ctrl.selectedEventTemplate) {
            if (ctrl.selectedEventTemplate.id) {
              const props = {
                templateId: ctrl.selectedEventTemplate.id,
                setSelected: false,
              };
              ctrl.getTemplate(props);
              ctrl.quantity = 0;
              ctrl.total = 0;
            } else {
              reset = true;
            }
          } else {
            ctrl.resetEvents();
            reset = true;
          }

          if (reset) {
            console.log('OrdersCreateController::onEventTemplateChange', reset);
            ctrl.selectedPriceList = null;
            ctrl.selectedDiscount = null;
            ctrl.discountedPriceList = null;
            ctrl.template.description = ctrl.getPartnerDescription(ctrl.partner);
            ctrl.template.name = '';
            ctrl.template.capacity = 0;
            ctrl.template.colorCategory = TemplatesService.getColorCategory();
            ctrl.spectrumConfig.color = TemplatesService.getColorCategory().backgroundColor;
          }
        },

        onPriceListChange: function (n, o) {
          // Only run if we are creating a custom event
          if (!ctrl.selectedEventTemplate.id || !(ctrl.currentTemplate.priceLists instanceof Array)) {
            ctrl.discountedPriceList = angular.copy(ctrl.selectedPriceList);
            // Set all discounts to prices because no discount has been selected
            if (ctrl.discountedPriceList && !ctrl.selectedDiscount) {
              console.log('OrdersCreateController::onPriceListChange -> reset');
              ctrl.resetPriceList();
            } else {
              console.log('OrdersCreateController::onPriceListChange -> fetch');
              ctrl.getDiscountedPriceList();
            }
            ctrl.calculateTotal();
          }
        },

        onDateFormatLoad: function (e, data) {
          ctrl.dateFormat = UserPreferencesService.getDateFormat('fieldDate', 'dateFormat');
          ctrl.hourFormat = UserPreferencesService.getHourFormat('standardTime', 'hourFormat');
        },

        onColorCodesUpdate: function (n, o) {
          if (n && n !== o) {
            ctrl.template.colorCategory = angular.copy(n);
          }
        },
      };

      $scope.ordersCreate = ctrl;

      ctrl.init();
    },
  ]).name;
